import { render, staticRenderFns } from "./DraggableTable.vue?vue&type=template&id=3eeadfa7&"
import script from "./DraggableTable.vue?vue&type=script&lang=js&"
export * from "./DraggableTable.vue?vue&type=script&lang=js&"
import style0 from "./DraggableTable.vue?vue&type=style&index=0&id=3eeadfa7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports